(() => {
  const appleProviderToken = '';
  const pagePlacement = () => location.pathname === '/' ? 'home' : location.pathname.replace(/^\/(pages|products|collections)\//, '').replace(/[^a-zA-Z0-9_-]/g, '_').slice(0, 24) || 'website';
  const placement = link => link.closest('emagineer-app-banner') ? 'mobile_banner' : link.closest('footer,.footer') ? 'footer' : link.closest('header,.header') ? 'header' : pagePlacement();
  const prepare = link => {
    if (!(link instanceof HTMLAnchorElement) || !link.hasAttribute('href')) return null;
    let url;
    try { url = new URL(link.getAttribute('href'), location.origin); } catch { return null; }
    const apple = /^(apps|itunes)\.apple\.com$/.test(url.hostname) && /\/id6739147739(?:\/|$)/.test(url.pathname);
    const android = url.hostname === 'play.google.com' && url.searchParams.get('id') === 'com.emagineer.app';
    if (!apple && !android) return null;
    const place = placement(link);
    if (apple) {
      if (!url.searchParams.has('ct')) url.searchParams.set('ct', ('web_' + place).slice(0, 30));
      url.searchParams.set('mt', '8');
      if (appleProviderToken) url.searchParams.set('pt', appleProviderToken);
    } else {
      const tags = {utm_source: 'emagineer_website', utm_medium: 'website', utm_campaign: 'app_download', utm_content: place};
      const referrer = new URLSearchParams(url.searchParams.get('referrer') || '');
      for (const [key, value] of Object.entries(tags)) {
        if (!url.searchParams.has(key)) url.searchParams.set(key, value);
        referrer.set(key, url.searchParams.get(key));
      }
      url.searchParams.set('referrer', referrer.toString());
    }
    if (link.href !== url.href) link.href = url.href;
    return {store_platform: apple ? 'ios' : 'android', link_placement: place, link_url: url.href, page_path: location.pathname};
  };
  const scan = root => {
    if (root instanceof HTMLAnchorElement) prepare(root);
    if (root.querySelectorAll) root.querySelectorAll('a[href*="apps.apple.com"],a[href*="itunes.apple.com"],a[href*="play.google.com"]').forEach(prepare);
  };
  const start = () => {
    scan(document);
    new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'attributes') prepare(record.target);
        else record.addedNodes.forEach(scan);
      }
    }).observe(document.documentElement, {childList: true, subtree: true, attributes: true, attributeFilter: ['href']});
    document.addEventListener('click', event => {
      const link = event.target instanceof Element ? event.target.closest('a') : null;
      if (!link) return;
      const data = prepare(link);
      if (!data) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({event: 'app_store_outbound_click', ...data});
      if (typeof window.gtag === 'function') window.gtag('event', 'app_store_click', {...data, transport_type: 'beacon'});
    }, true);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
